import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import Content from './views/Content.vue';
import * as contentSections from '@/data/sections';
import store from './store';

Vue.use(Router);

function isParamValid(maxValue, value) {
  return new RegExp(`^[1-${maxValue}]{1}$`).test(value);
}

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      pathToRegexpOptions: { strict: true }
    },
    {
      pathToRegexpOptions: { strict: true },
      path: '/psoriasis/:section/',
      name: 'Psoriasis-section',
      component: Content,
      meta: {
        page: 'Psoriasis',
        name: contentSections.psoriasis
      },
      beforeEnter: (to, from, next) => {
        if (
          isParamValid(contentSections.psoriasis.length, to.params.section) ===
          false
        ) {
          next('/');
        }
        next();
      }
    },
    {
      pathToRegexpOptions: { strict: true },
      path: '/psoriasis/:section/:subsection/',
      name: 'Psoriasis-subsection',
      component: Content,
      meta: {
        page: 'Psoriasis'
      },
      beforeEnter: (to, from, next) => {
        if (
          isParamValid(contentSections.psoriasis.length, to.params.section) ===
            false ||
          !contentSections.psoriasis[parseInt(to.params.section) - 1]
            .subsections ||
          isParamValid(
            contentSections.psoriasis[parseInt(to.params.section) - 1]
              .subsections.length,
            to.params.subsection
          ) === false
        ) {
          next('/');
        }
        next();
      }
    },
    {
      pathToRegexpOptions: { strict: true },
      path: '/psoriasis/',
      name: 'Psoriasis',
      redirect: { name: 'Psoriasis-section', params: { section: '1' } },
      component: Content,
      meta: {
        page: 'Psoriasis'
      }
    },
    {
      pathToRegexpOptions: { strict: true },
      path: '/tremfya/:section/:subsection/',
      name: 'Tremfya-subsection',
      component: Content,
      meta: {
        page: 'Tremfya'
      },
      beforeEnter: (to, from, next) => {
        if (
          isParamValid(contentSections.tremfya.length, to.params.section) ===
            false ||
          !contentSections.tremfya[parseInt(to.params.section) - 1]
            .subsections ||
          isParamValid(
            contentSections.tremfya[parseInt(to.params.section) - 1].subsections
              .length,
            to.params.subsection
          ) === false
        ) {
          next('/');
        }
        next();
      }
    },
    {
      pathToRegexpOptions: { strict: true },
      path: '/tremfya/:section/',
      name: 'Tremfya-section',
      component: Content,
      meta: {
        page: 'Tremfya'
      },
      beforeEnter: (to, from, next) => {
        if (
          isParamValid(contentSections.tremfya.length, to.params.section) ===
          false
        ) {
          next('/');
        }

        next();
      }
    },
    {
      pathToRegexpOptions: { strict: true },
      path: '/tremfya/',
      name: 'Tremfya',
      redirect: { name: 'Tremfya-section', params: { section: '1' } },
      component: Content,
      meta: {
        page: 'Tremfya'
      }
    },
    { path: '*', redirect: '/' }
  ],
  scrollBehavior(to) {
    let top = 0;

    if (to.meta.page === 'Psoriasis' || to.meta.page === 'Tremfya') {
      top =
        to.meta.page === 'Psoriasis'
          ? store.state.psoriasisScrollPos
          : store.state.tremfyaScrollPos;

      console.log('SCROLL BEHAIVIOR', top);
    }

    return new Promise(resolve => {
      setTimeout(() => {
        resolve({ x: 0, y: top });
      }, 500);
    });
  }
});
export default router;
// {
//   path: "/about",
//   name: "about",
//   // route level code-splitting
//   // this generates a separate chunk (about.[hash].js) for this route
//   // which is lazy-loaded when the route is visited.
//   // component: () =>
//   //   import(/* webpackChunkName: "about" */ "./views/About.vue")
// }

router.beforeEach((to, from, next) => {
  store.commit('setExplicitSection', '');
  store.commit('setExplicitSubsection', '');
  store.commit('setExplicitSlideIndex', null);

  // push to datalayer Home->Psoriasis
  if (from.name === 'Home' && to.name === 'Psoriasis-section') {
    store.commit('updateDataLayer', 'psoriasis');
  }
  // push to datalayer Home->Tremfia
  if (from.name === 'Home' && to.name === 'Tremfya-section') {
    store.commit('updateDataLayer', 'tremfya');
  }
  // push to datalayer Tremfia->Psoriasis
  if (
    (from.name === 'Tremfya-section' || from.name === 'Tremfya-subsection') &&
    (to.name === 'Psoriasis-section' || to.name === 'Psoriasis-subsection')
  ) {
    store.commit('updateDataLayer', ' psoriasis');
  } else if (
    // push to datalayer Psoriasis->Tremfia
    (from.name === 'Psoriasis-section' ||
      from.name === 'Psoriasis-subsection') &&
    (to.name === 'Tremfya-section' || to.name === 'Tremfya-subsection')
  ) {
    store.commit('updateDataLayer', 'tremfya');
  }

  // push to datalayer Tremfia sections/subsection
  if (from.name === 'Tremfya-section' && to.name === 'Tremfya-subsection') {
    store.commit('updateDataLayer', 'tremfya-subsection');
  } else if (
    from.name === 'Tremfya-subsection' &&
    to.name === 'Tremfya-section'
  ) {
    store.commit('updateDataLayer', 'tremfya-section');
  }
  // push to datalayer Psoriasis sections/subsection
  if (from.name === 'Psoriasis-section' && to.name === 'Psoriasis-subsection') {
    store.commit('updateDataLayer', 'psoriasis-subsection');
  } else if (
    from.name === 'Psoriasis-subsection' &&
    to.name === 'Psoriasis-section'
  ) {
    store.commit('updateDataLayer', 'psoriasis-section');
  }

  next();
});
